import React from 'react';
// eslint-disable-next-line
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer, fade, IconButton, Grid, Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import { Close } from '@material-ui/icons'
import { useTranslation } from 'react-i18next';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    fullList: {
        width: 'auto',
    },
    drawerPaper: {
        width: 400,
        padding: theme.spacing(2)
    },
    AccordionRoot: {
        border: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        }
    },
    expanded: {},
    AccordionSummaryRoot: {
        backgroundColor: fade(theme.palette.primary.main, 0.0675),
        borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        marginBottom: -1,
        minHeight: '32px!important',
        '&$expanded': {
            minHeight: 32,
        }
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        margin: theme.spacing(0, 0),
    },
    AccordionSummaryTitle: {
        fontSize: '0.8rem',
        fontWeight: theme.typography.fontWeightMedium
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
    },
    card: {
        height: '100%'
    },
    cardHeaderRoot: {
        backgroundColor: fade(theme.palette.primary.main, 0.00675),
        padding: theme.spacing(1, 1, 0, 2)
    },
    cardContent: {
        padding: theme.spacing(0, 1, 2, 2),

    },
    cardHeaderTitle: {
        fontSize: '0.8rem',
        fontWeight: theme.typography.fontWeightMedium
    },
    infoLetter: {
        width: 22,
        height: 22,
        backgroundColor: '#fff',
        borderRadius: '50%',
        fontSize: '0.875rem',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: '22px'
    },
    // AccordionSummaryContent: {
    //     margin: `${theme.spacing(1, 0)}!important`,
    // },
    // AccordionSummaryContentExpanded: {
    //     margin: theme.spacing(0, 0),
    // },

    AccordionSummaryExpandIcon: {
        transform: 'rotate(0deg)!important',
        marginRight: '0!important'
    },
    // AccordionDetailsRoot: {
    //     padding: theme.spacing(2),
    // },
}))

const ObjectsDrawer = ({ id_obiektu, cechyobiektu }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [state, setState] = React.useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState(open);
    };

    return (
        <div>
            {/* <IconButton size={"small"} onClick={toggleDrawer(true)}><small className={classes.infoLetter}>i</small></IconButton> */}
            <Accordion
                square
                // expanded={expanded === `obiekt-${id_obiektu}`}
                // onChange={handleChange(`obiekt-${id_obiektu}`)}
                classes={{ root: classes.AccordionRoot }}
            >
                <AccordionSummary
                    aria-controls={`obiekt-${id_obiektu}-content`}
                    id={`obiekt-${id_obiektu}-header`}
                    onClick={toggleDrawer(true)}
                    //expandIcon={<Icon>keyboard_arrow_down</Icon>}
                    expandIcon={<IconButton size={"small"} ><small className={classes.infoLetter}>i</small></IconButton>}

                    classes={{
                        root: classes.AccordionSummaryRoot,
                        content: classes.AccordionSummaryContent,
                        expanded: classes.AccordionSummaryContentExpanded,
                        expandIcon: classes.AccordionSummaryExpandIcon
                    }}
                    // style={{ cursor: 'default' }}
                >
                    <Typography className={classes.AccordionSummaryTitle}>
                        {t('obiekt.cechy')}
                        {/* <small>({cechyobiektu.length})</small>: */}
                    </Typography>
                </AccordionSummary>
            </Accordion>
            <Drawer
                anchor={'right'}
                open={state}
                onClose={toggleDrawer(false)}
                classes={{ paper: classes.drawerPaper }}
            >
                {/* <pre>{JSON.stringify(cechyobiektu, null,4)}</pre> */}
                <Grid container spacing={1} alignItems={'center'} style={{ marginBottom: 8 }}>
                    <Grid item xs>
                        <IconButton size={'small'} onClick={toggleDrawer(false)}>
                            <Close fontSize={'small'} />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    {cechyobiektu.map(feature => {
                        // feature.aktyprawne.length && console.log(feature)
                        return (
                            <Grid item xs={12} md={12} key={feature.id_cechy}>
                                <Card variant="elevation" className={classes.card} elevation={0}>
                                    <CardHeader
                                        classes={{ root: classes.cardHeaderRoot, title: classes.cardHeaderTitle }}
                                        title={feature.nazwa_cechy}
                                    />
                                    <CardContent className={classes.cardContent}>
                                        {/* <code style={{ fontStyle: "italic" }}>{feature.definicja_cechy || t('obiekt.no_feature_description')}</code> */}
                                        <code style={{ fontStyle: "italic", fontFamily: "Fira Sans, sans-serif"}}>{feature.definicja_cechy || ''}</code>
                                    </CardContent>
                                    <Divider />
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </Drawer>
        </div>
    );
}

export default ObjectsDrawer;